import React, { FunctionComponent } from "react";
import { SvgWrapper } from "./styles";
import { IconProps, curbiqIcons, AllIcons } from "./helpers";

export const Icon: FunctionComponent<IconProps> = ({ icon, ...props }: IconProps) => (
    <SvgWrapper
        id={icon}
        style={props.style}
        {...props}
        pathFill={props.pathFill}
        svgFill={props.fill}
        pathStroke={props.pathStroke}
        svgStroke={props.stroke}
        svgbackgroundColor={props.svgbackgroundColor}
        isLargeIcon={props.isLargeIcon}
        rotateIcon={props.rotateIcon}
        isSmallIcon={props.isSmallIcon}
    >
        {curbiqIcons[icon as keyof AllIcons]}
    </SvgWrapper>
);

Icon.defaultProps = {
    className: "",
    svgbackgroundColor: "transparent",
    isSmallIcon: false,
    isLargeIcon: false
};
